var w = Object.defineProperty;
var p = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, I = Object.prototype.propertyIsEnumerable;
var O = (o, n, r) => n in o ? w(o, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[n] = r, t = (o, n) => {
  for (var r in n || (n = {}))
    N.call(n, r) && O(o, r, n[r]);
  if (p)
    for (var r of p(n))
      I.call(n, r) && O(o, r, n[r]);
  return o;
};
var c = (o, n) => {
  var r = {};
  for (var s in o)
    N.call(o, s) && n.indexOf(s) < 0 && (r[s] = o[s]);
  if (o != null && p)
    for (var s of p(o))
      n.indexOf(s) < 0 && I.call(o, s) && (r[s] = o[s]);
  return r;
};
import { jsxs as z, jsx as a } from "react/jsx-runtime";
import e from "../../../node_modules/prop-types/index.es.js";
import { forwardRef as B, useId as F } from "react";
import * as H from "./style.es.js";
import { Base as M, StartIcon as U, EndIcon as V, Textarea as Z, Label as v } from "./style.es.js";
import { Helper as D } from "../../DataDisplay/Helper/Helper.es.js";
import { COMPONENT_SIZE as P } from "../../../constants/sizes.es.js";
import { INPUT_VARIANT as j } from "../../../constants/inputVariant.es.js";
const f = B((J, L) => {
  var h = J, {
    block: o,
    className: n,
    endIcon: r,
    error: s,
    helperProps: C,
    helperText: k,
    id: b,
    inputProps: E = {},
    label: l,
    maxLength: T,
    name: S,
    onChange: _,
    rounded: A,
    size: i = P.md,
    startIcon: $,
    success: u,
    value: d = "",
    variant: m = j.standard
  } = h, g = c(h, [
    "block",
    "className",
    "endIcon",
    "error",
    "helperProps",
    "helperText",
    "id",
    "inputProps",
    "label",
    "maxLength",
    "name",
    "onChange",
    "rounded",
    "size",
    "startIcon",
    "success",
    "value",
    "variant"
  ]);
  const y = F(), x = E, {
    className: R
  } = x, q = c(x, [
    "className"
  ]);
  return /* @__PURE__ */ z(M, { className: n, $block: o, $variant: m, $error: s, $success: u, $size: i, $rounded: A, $hasLabel: !!l, $disabled: g.disabled, children: [
    $ && /* @__PURE__ */ a(U, { $variant: m, $size: i, children: $ }),
    r && /* @__PURE__ */ a(V, { $variant: m, $size: i, children: r }),
    /* @__PURE__ */ a(Z, t(t({ ref: L, id: b || y, name: S, value: d, placeholder: " ", onChange: _, maxLength: T, className: R }, g), q)),
    l && /* @__PURE__ */ a(v, { htmlFor: b || y, children: l }),
    /* @__PURE__ */ a(D, t({ text: k, error: s, success: u, maxLength: T, size: i }, t({
      counter: d == null ? void 0 : d.length
    }, C)))
  ] });
}), G = {
  block: e.bool,
  className: e.string,
  disabled: e.bool,
  endIcon: e.oneOfType([e.string, e.node]),
  error: e.bool,
  helperProps: e.any,
  helperText: e.oneOfType([e.string, e.node]),
  id: e.string,
  inputProps: e.any,
  label: e.oneOfType([e.string, e.node]),
  loading: e.bool,
  maxLength: e.number,
  name: e.string,
  onChange: e.func,
  onClick: e.func,
  rounded: e.bool,
  size: e.oneOf(Object.values(P)),
  startIcon: e.oneOfType([e.string, e.node]),
  success: e.bool,
  value: e.string,
  variant: e.oneOf(Object.values(j))
};
f.S = H;
f.displayName = "Textarea";
f.propTypes = G;
export {
  f as Textarea,
  G as textareaPropTypes
};
//# sourceMappingURL=Textarea.es.js.map
